import listComponent from '@/util/proto/listComponent'
import orderItem from './detail'
import orderCancel from './cancel'
import orderConfirm from './confirm'
import orderEdit from './edit'

import orderValidate from './validate'
import orderReject from './reject'
import orderSign from './sign'
import orderFinance from './finance'

import orderReceive from './receive'
import orderLogistics from './logistics'

const columns_ = [
  {
    title:'订单编号',
    key:'orderInfo.orderNo',
    minWidth:150,
  },
  {
    title: '下单人',
    key: 'orderBuyer.name',
    minWidth:120,
  },
  {
    title: '手机号',
    key: 'orderBuyer.phone',
    minWidth:120,
  },
  {
    title: '状态',
    key: 'orderInfo.orderStateText',
    minWidth:120,
  },
  {
    title: '流程状态',
    key: 'orderInfo.flowStateText',
    minWidth:120,
  },
  {
    title: '下单时间',
    key: 'orderInfo.dealDatetimeText',
    minWidth:150,
  },
  {
    title: '商品',
    key: 'orderGoods.skuName',
    minWidth:120,
  },
  {
    title: '数量',
    key: 'orderInfo.goodsNum',
    minWidth:120,
  },
  {
    title: '购买主体',
    key: 'orderInfo.buySubjectText',
    minWidth:120,
  },
  {
    title: '购买保险',
    key: 'orderInfo.isInsuranceText',
    minWidth:120,
  },
  {
    title: '是否分期',
    key: 'orderInfo.isStagesText',
    minWidth:120,
  },
  
]

export default {
  extends: listComponent,

  data() {
    return {
      columns: [
        ...columns_,
      ],
      data: [],
      params:{
        memberPhone:null , 
        memberName:null ,
        orderNo:null, 
        orderState:null,
        isStages:null,
        dealDatetimeStart:null,
        dealDatetimeEnd:null,
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total:0
      },
      loading: false,
      modalVisible:false,
      modalSkuVisible:false,
      itemTitle:'',
      selection:[],

      showStateFilter: true
    }
  },

  props:{
    actions:{
      default:function(){
        let actions = [{
            title: '操作',
            key: 'operation',
            width: 200,
            align: 'center',
            fixed: 'right',
            render: (h, { row }) => {
              let acts = []
              acts.push(<a on-click={()=>this.view(row)}>查看</a>)
              
              let orderState = row.orderInfo.orderState
              let flowState = row.orderInfo.flowState
              let installment = row.orderInfo.isStages == 1

              if(orderState == 1){
                acts.push(<a on-click={()=>this.edit(row)}>编辑</a>)
                acts.push(<a on-click={()=>this.confirm(row)}>确认</a>)
                acts.push(<a on-click={()=>this.cancel(row)}>作废</a>)
              }

             
              //待审核
              else if( orderState == 2 ){

                // 未签约成功 2 待签约 , 3 签约中, 4 签约失败 , 5 签约成功
                if( flowState < 5 && flowState >=2 ){
                  acts.push(<a on-click={()=>this.sign(row)}>签约</a>)
                }
                
                if( installment && flowState >= 5 && flowState < 7){
                  acts.push(<a on-click={()=>this.signForInstallment(row)}>分期</a>)
                }

                if( 
                  (installment && flowState == 7) //分期 且 签约完成 可 审核
                  || (!installment && flowState == 5 ) //全款 且 签约完成 可 审核
                ){
                  acts.push(<a on-click={()=>this.validate(row)}>审核</a>)
                }

                acts.push(<a on-click={()=>this.cancel(row)}>作废</a>)
                acts.push(<a on-click={()=>this.reject(row)}>驳回</a>)


              }

              else if(orderState == 3){
                acts.push(<a on-click={()=>this.setLogistics(row)}>物流</a>)
                acts.push(<a on-click={()=>this.receive(row)}>收货</a>)
              }
  
              return this.$utils.link(acts, <Divider type="vertical" />)
            }
        }]
        return actions
      }
    },

    defaultState:{
      default: ''
    }
  },

  computed: {
    
  },
  created(){
    if( this.defaultState ){
      this.params.orderState = this.defaultState
      this.showStateFilter = false
    }

    this.def = { ...this.params }
    this.columns.push( ...this.actions )
    this.search()
  },

  methods: {

    search() {
      let params = {search : { ...this.params }, pageSize:this.page.pageSize , pageNum : this.page.pageNum }
      this.loading = true
      this.$request.orders(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data =  this.$utils.conv( this.$utils.flat( resp.data.list || [] ), {
            'orderInfo.dealDatetime':'time' , 
            'orderInfo.buySubject':'$buySubject',
            'orderInfo.isInsurance':'$NY',
            'orderInfo.isStages':'$NY' , 
            'orderInfo.orderState':'$orderState',
            'orderInfo.flowState':'$flowState',
          })
          this.page.total = resp.data.total || 0
        }
      })
    },

    view(record){
      this.$refs['item'].init( record.orderInfo.id )
    },
    edit(record){
      this.$refs['itemEdit'].init( record.orderInfo.id )
    },
    confirm(row){
      this.$refs['orderConfirm'].init( row.orderInfo.id )
    },
    cancel(row){
      this.$refs['orderCancel'].init( row.orderInfo.id )
    },

    validate(row){
      this.$refs['orderValidate'].init( row.orderInfo.id )
    },


    sign(row){
      this.$refs['orderSign'].init( row.orderInfo )
    },

    signForInstallment(row){
      this.$refs['orderFinance'].init( row.orderInfo.id , `分期订单编号：${row.orderInfo.orderNo}`)
    },

    reject(row){
      this.$refs['orderReject'].init( row.orderInfo.id )
    },

    receive(row){
      this.$refs['orderReceive'].init( row.orderInfo.id )
    },

    setLogistics(row){
      this.$refs['orderLogistics'].init( row.orderInfo.id )
    },
    reset(){
      this.$utils.fill(this.params , this.def)
      this.search()
    },

    handleUpdate(){
      this.modalVisible = false
      this.search()
    },

    handleUpdatedDate(a){
      this.params.dealDatetimeStart = a[0]
      this.params.dealDatetimeEnd = a[1]
    },


    handleChange( pageNum , pageSize ){
      if( this.page.pageNum != pageNum || this.page.pageSize != pageSize){
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.search()
      }
    },

    handleSelect(selection){
      this.selection = selection.map(i=>i.id)
    }
  },
  render() {
    return (
      <sl-page>
        <div class="page-filter">
          <sl-search on-search={this.search} on-reset={this.reset}>
            <sl-search-item label="">
              <i-input v-model={this.params.orderNo} placeholder="订单编号" />
            </sl-search-item>
            <sl-search-item label="">
              <i-input v-model={this.params.memberPhone} placeholder="手机号" />
            </sl-search-item>
            <sl-search-item label="">
              <i-input v-model={this.params.memberName} placeholder="下单人" />
            </sl-search-item>
            <sl-search-item label="">
              <sl-select v-model={this.params.isStages} placeholder="是否分期"  dict="$NY"></sl-select>
            </sl-search-item>
            <sl-search-item label="">
              <sl-select v-model={this.params.orderState} placeholder="订单状态" dict="$orderState"></sl-select>
            </sl-search-item>
            <sl-search-item label="">
              <DatePicker value={[this.params.dealDatetimeStart , this.params.dealDatetimeEnd]} type="daterange" placement="bottom-start" placeholder="下单时间" on-on-change="handleUpdatedDate" style="width:100%"></DatePicker>
            </sl-search-item>

          </sl-search>
        </div>
        <div class="pg-bd">

          <sl-table show-header={true} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange}>
          </sl-table>
        </div>
        <orderItem ref="item" on-on-update="handleUpdate" />
        <orderEdit ref="itemEdit" on-on-update="handleUpdate" />
        <orderCancel ref="orderCancel" on-on-update="handleUpdate" />
        <orderConfirm ref="orderConfirm" on-on-update="handleUpdate" />
        <orderFinance ref="orderFinance" on-on-update="handleUpdate" />
        <orderCancel ref="orderCancel" on-on-update="handleActionUpdate" />
        <orderReject ref="orderReject" on-on-update="handleActionUpdate" />
        <orderValidate ref="orderValidate" on-on-update="handleActionUpdate" />
        <orderSign ref="orderSign" on-on-update="handleActionUpdate" />
        <orderReceive ref="orderReceive" on-on-update="handleUpdate" />
        <orderLogistics ref="orderLogistics" on-on-update="handleUpdate" />
      </sl-page>
    )
  }
}
